/**
 * @generated SignedSource<<8d9aff3ac6479fee5524af7540f99129>>
 * @relayHash 6fefc535fcf3d11f8f68b436f2a1342b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da0ca1c06e8c66bde4d91ca2557ec6db283a78561a5b74e759b55fd8b125a7a4

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type ActivitiesFilterType = "AND" | "OR" | "%future added value";
export type ActivityFilter = {
  actors?: ReadonlyArray<string> | null;
  arguments?: ActivityFilterArgs | null;
  collabContextId?: string | null;
  rootContainerIds?: ReadonlyArray<string> | null;
  type?: ActivitiesFilterType | null;
};
export type ActivityFilterArgs = {
  containerIds?: ReadonlyArray<string> | null;
  earliestStart?: AGG$DateTime | null;
  eventTypes?: ReadonlyArray<string> | null;
  latestStart?: AGG$DateTime | null;
  objectTypes?: ReadonlyArray<string> | null;
  products?: ReadonlyArray<string> | null;
  transitions?: ReadonlyArray<TransitionFilter> | null;
};
export type TransitionFilter = {
  from: string;
  to: string;
};
export type SmartsRecommendationsQuery = {
  context: SmartsContext;
  excludeInactive?: boolean | null;
  excludeSelf?: boolean | null;
  maxNumberOfResults?: number | null;
  modelRequestParams: SmartsModelRequestParams;
  requestingUserId: string;
  sessionId?: string | null;
};
export type SmartsContext = {
  additionalContextList?: ReadonlyArray<SmartsKeyValue> | null;
  containerId?: string | null;
  excludeCollaboratorRecommendations?: boolean | null;
  objectId?: string | null;
  product?: string | null;
  tenantId: string;
  userId: string;
};
export type SmartsKeyValue = {
  key: string;
  value: string;
};
export type SmartsModelRequestParams = {
  caller: string;
  experience: string;
  featureServiceModel?: string | null;
};
export type UserProfilePreviewRelayQuery$variables = {
  filter?: ActivityFilter | null;
  first: number;
  recommendationsQuery: SmartsRecommendationsQuery;
  reportingLinesAaid: string;
  reportingLinesOrgId: string;
  reportingLinesSiteId: string;
  singleUserAccountId: string;
  singleUserRequestingUserId: string;
  singleUserTenantId: string;
};
export type UserProfilePreviewRelayQuery$data = {
  readonly activity: Result<{
    readonly workedOn: {
      readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_workedOn">;
    };
  } | null, unknown>;
  readonly knowledgeDiscovery: {
    readonly reportingLines: Result<{
      readonly __typename: "QueryError";
      readonly __typename: "QueryError";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null, unknown>;
    readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_reportingLines" | "UserProfilePreviewRelayContent_user">;
  } | null;
  readonly smarts: Result<{
    readonly recommendedUser: Result<ReadonlyArray<{
      readonly __typename: "SmartsRecommendedUser";
    } | null> | null, unknown>;
    readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_smarts">;
  } | null, unknown>;
};
export type UserProfilePreviewRelayQuery = {
  response: UserProfilePreviewRelayQuery$data;
  variables: UserProfilePreviewRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationsQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesAaid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesOrgId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesSiteId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserAccountId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserRequestingUserId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserTenantId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "recommendationsQuery",
    "variableName": "recommendationsQuery"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "Variable",
    "name": "aaid",
    "variableName": "reportingLinesAaid"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "reportingLinesOrgId"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "reportingLinesSiteId"
  }
],
v14 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "singleUserAccountId"
  },
  {
    "kind": "Variable",
    "name": "requestingUserId",
    "variableName": "singleUserRequestingUserId"
  },
  {
    "kind": "Variable",
    "name": "tenantId",
    "variableName": "singleUserTenantId"
  }
],
v15 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v15/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/)
    ]
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "url"
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v25 = [
  (v24/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v26 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v27 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v28 = [
  (v22/*: any*/),
  (v19/*: any*/)
],
v29 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
],
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = {
  "kind": "ScalarField",
  "name": "picture"
},
v32 = {
  "kind": "ScalarField",
  "name": "email"
},
v33 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v34 = [
  (v33/*: any*/)
],
v35 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v30/*: any*/),
      (v31/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": (v34/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserProfilePreviewRelayQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "concreteType": "Activity",
          "kind": "LinkedField",
          "name": "activity",
          "plural": false,
          "selections": [
            {
              "args": (v9/*: any*/),
              "concreteType": "ActivityConnection",
              "kind": "LinkedField",
              "name": "workedOn",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "UserProfilePreviewRelayContent_workedOn"
                }
              ]
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "kind": "CatchField",
        "field": {
          "concreteType": "SmartsQueryApi",
          "kind": "LinkedField",
          "name": "smarts",
          "plural": false,
          "selections": [
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "UserProfilePreviewRelayContent_smarts"
            },
            {
              "kind": "CatchField",
              "field": {
                "args": (v10/*: any*/),
                "concreteType": "SmartsRecommendedUser",
                "kind": "LinkedField",
                "name": "recommendedUser",
                "plural": true,
                "selections": (v12/*: any*/)
              },
              "to": "RESULT"
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "kind": "CatchField",
            "field": {
              "args": (v13/*: any*/),
              "kind": "LinkedField",
              "name": "reportingLines",
              "plural": false,
              "selections": (v12/*: any*/)
            },
            "to": "RESULT"
          },
          {
            "args": (v14/*: any*/),
            "kind": "FragmentSpread",
            "name": "UserProfilePreviewRelayContent_user"
          },
          {
            "args": (v13/*: any*/),
            "kind": "FragmentSpread",
            "name": "UserProfilePreviewRelayContent_reportingLines"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserProfilePreviewRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceDatabaseLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceEmbedLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v21/*: any*/),
                                "type": "ConfluenceFooterComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v21/*: any*/),
                                "type": "ConfluenceInlineComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "TownsquareGoal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "TownsquareProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "TownsquareComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "TrelloBoard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "TrelloCard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "DevOpsDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "DevOpsDesign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "ExternalRemoteLink"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "MercuryFocusArea"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "MercuryPortfolio"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "RadarPosition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "RadarView"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "CompassComponent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "AssetsObject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "AssetsObjectType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "AssetsSchema"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          (v19/*: any*/)
                        ]
                      },
                      (v19/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v32/*: any*/),
                      {
                        "concreteType": "AtlassianAccountUserExtendedProfile",
                        "kind": "LinkedField",
                        "name": "extendedProfile",
                        "plural": false,
                        "selections": (v34/*: any*/)
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  },
                  (v19/*: any*/)
                ]
              },
              (v19/*: any*/),
              (v11/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryUserProfile",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "department"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "organization"
                      },
                      {
                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                        "kind": "LinkedField",
                        "name": "thirdPartyIntegrations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "externalId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "integrationId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoverySingleUser"
              }
            ]
          },
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "reportingLines",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v35/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": (v35/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": (v35/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "peers",
                    "plural": true,
                    "selections": (v35/*: any*/)
                  }
                ],
                "type": "KnowledgeDiscoveryReportingLines"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "da0ca1c06e8c66bde4d91ca2557ec6db283a78561a5b74e759b55fd8b125a7a4",
    "metadata": {},
    "name": "UserProfilePreviewRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4fecf1ce06964a7314f5af350cc76710";

export default node;
